export const PAY_RANGE_VERSION_STATE = {
  DRAFT: "draft",
  IN_FORCE: "in-force",
  VOIDED: "voided",
  RETIRED: "retired",
};

/**
 * Row ⋯ menu per version state. Voided versions and every version of a retired or
 * archived pay range are read-only, so they get no menu.
 */
export function buildPayRangeVersionMenuItems({ status, locked = false, readOnly = false } = {}) {
  if (
    readOnly ||
    status === PAY_RANGE_VERSION_STATE.VOIDED ||
    status === PAY_RANGE_VERSION_STATE.RETIRED
  ) {
    return [];
  }

  if (status === PAY_RANGE_VERSION_STATE.DRAFT) {
    return [
      { name: "Edit", value: "edit", icon: "icons/dropdown/edit-05.svg" },
      { name: "Publish", value: "publish", icon: "icons/dropdown/send-01.svg" },
      {
        name: "Discard draft",
        value: "discard",
        icon: "icons/dropdown/trash-01.svg",
        negative: true,
      },
    ];
  }

  if (status !== PAY_RANGE_VERSION_STATE.IN_FORCE) return [];

  const correct = {
    name: "Correct",
    value: "correct",
    icon: "icons/dropdown/rename.svg",
  };
  const voidItem = {
    name: "Void",
    value: "void",
    icon: "icons/dropdown/slash-circle-01.svg",
    negative: true,
  };

  if (!locked) return [correct, voidItem];

  return [
    correct,
    voidItem,
    {
      name: "View pay plans",
      value: "view-pay-plans",
      icon: "icons/dropdown/arrow-square-right.svg",
    },
  ];
}
